module.exports = __webpack_public_path__ + "img/TheosLogoYellow.e1a69c64.svg";